import { marketingHead } from "@marketing/components/blocks";
import { Chevron, mkLink } from "@marketing/components/MkButton";
import { DemoForm } from "@marketing/demo/DemoForm";
import { CONTACT_EMAIL, WHATSAPP_URL } from "@marketing/site";
import { createFileRoute } from "@tanstack/react-router";

const STEPS = [
	{
		title: "We talk for 20 minutes",
		text: "About your stores, your catalog, your shoppers' languages and where they buy.",
	},
	{
		title: "We load your catalog",
		text: "A demo assistant on your own products and prices, in your languages.",
	},
	{
		title: "You try it",
		text: "In a chat, on WhatsApp and on a call, before you decide anything.",
	},
];

export const Route = createFileRoute("/_marketing/demo")({
	head: () =>
		marketingHead({
			title: "Book a Demo on Your Own Catalog | Hephon Commerce",
			description:
				"Book a demo of Hephon Commerce, the AI shopping assistant for supermarkets and retailers. We set it up on your own catalog, in your shoppers' languages.",
			path: "/demo",
			breadcrumb: ["Book a demo"],
		}),
	component: DemoPage,
});

function DemoPage() {
	return (
		<section aria-labelledby="page-title">
			<div className="mk-container grid gap-12 pt-14 pb-24 sm:pt-20 lg:grid-cols-[1fr_1.1fr] lg:gap-20 lg:pb-32">
				<div>
					<p className="mk-kicker text-(--mk-ink-2)">Book a demo</p>
					<h1 id="page-title" className="mk-h1 mt-3">
						See it on your own catalog.
					</h1>
					<p className="mk-lead mt-5 max-w-lg text-(--mk-ink-2)">
						Tell us a little about your store. We set up a demo of
						the assistant with your products and your shoppers'
						languages.
					</p>
					<ol className="mt-12 space-y-7">
						{STEPS.map((step, i) => (
							<li key={step.title} className="flex gap-5">
								<span className="font-semibold text-(--mk-faint) text-3xl tracking-[-0.04em] tabular-nums">
									{i + 1}
								</span>
								<span>
									<span className="block font-semibold text-[17px]">
										{step.title}
									</span>
									<span className="mt-1 block text-(--mk-muted) text-[16px]">
										{step.text}
									</span>
								</span>
							</li>
						))}
					</ol>
					<div className="mt-12 flex flex-wrap gap-x-8 gap-y-3 text-[16px]">
						<a
							href={WHATSAPP_URL}
							target="_blank"
							rel="noopener"
							className={mkLink()}
						>
							Prefer WhatsApp? Message us
							<Chevron />
						</a>
						<a
							href={`mailto:${CONTACT_EMAIL}`}
							className={mkLink()}
						>
							{CONTACT_EMAIL}
							<Chevron />
						</a>
					</div>
				</div>
				<div className="rounded-[32px] bg-(--mk-mist) p-6 sm:p-10">
					<DemoForm />
				</div>
			</div>
		</section>
	);
}
